<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ date }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            Consumer Report# {{ reportStore.reports[userStore.user.email].report.slug }}
        </p>
        <p style="text-align: center;">
            Notice to Agent is notice to principal notice to principal is notice to agent.
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            On ( Put date they received late payment letter) you received my dispute regarding some transactions and late payments that you and {{ creditor.furnisher_name }} furnished to my consumer report and when I disputed these exclusions using the FCRA I received a response from you {{ creditBureau.address_name }} stating that the account was verified!!!
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p class="letter-content">
            The law clearly states that;
        </p>
        <p class="letter-content">
            (2)Exclusions.—Except as provided in paragraph (3), the term “consumer report” does not include—
        </p>
        <p class="letter-content">
            (i)
            <br />
            report containing information solely as to transactions or experiences between the consumer and the person making the report;
        </p>
        <p class="letter-content">
            how can you validate a dispute regarding information that is excluded from the consumer report? The law says transactions are not apart of my consumer! So how can you validate a late payment?
        </p>
        <p class="letter-content">
            Further more lets take a look at 15 USC 1666b 
        </p>
        <p class="letter-content">
            <b>
                (a)Time to make payments
            </b>
        </p>
        <p class="letter-content">
            A creditor may not treat a payment on a credit card account under an open end consumer credit plan as late for any purpose, unless the creditor has adopted reasonable procedures designed to ensure that each periodic statement including the information required by section 1637(b) of this title is mailed or delivered to the consumer not later than 21 days before the payment due date.
        </p>
        <p class="letter-content">
            I am requesting all information pursuant Rule 1002 on 15 USC 1666b and the procedure that was used to authenticate accuracy;
        </p>
        <p class="letter-content">
            What reasonable procedure that you have adopted designed to ensure that each peridioc statement including information required by  section 1637b was mailed or delivered to the consumer not later than 21 days before the payment due date.
        </p>
        <p class="letter-content">
            The only way for you to validate a “latepayment” is to ensure that 15 USC 1666b was done in compliance METRO2 compliance and FCRA compliance!! to the specifications of the law 15 USC 1666b! Further more this process must be certified by an agent that the information is accurate.
        </p>
        <p class="letter-content">
            We are requesting the Certification of accuracy and the agent/s that were involved in the certification process, that certified that the information is complete and accurate.
        </p>
        <p class="letter-content">
            Failure to provide this information clearly admits that proper steps and certification was not done in compliance with the law 15 USC 1666b, and you {{ creditBureau.address_name }} have fraudulently verified an account without a reasonable procedure as required by law.
        </p>
        <p class="letter-content">
            Delete these incomplete and unverifiable accounts and transactions from my consumer reports:
        </p>
        <p class="letter-content">
            List accounts you want deleted here.
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
            </strong>
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p style="page-break-after: always;">
            Your truly  <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
